'use strict'

import React from 'react';

import Layout from './Layout.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';
import HighlightReport from './log/HighlightReport.jsx';
import {HighlightReportSlideTitle} from './log/HighlightReport.jsx';
import {RiskReport} from './Risk.jsx';
import {IssueReport} from './Change.jsx';
import sortByDate from '../app/utils/sortByDate.js';
import Slides from './components/Slides.jsx';

export class Report extends React.Component {
  render() {
    let link=(
      this.props.project.isRelease!==undefined
        ? "/releases/"
        : this.props.project.isProgramme!==undefined
          ? "/programmes/"
          : this.props.project.isProduct!==undefined
            ? "/products/"
            : "/projects/"
      )+this.props.project.id+"/highlight?version=3";
    let reports=this.props.project.highlights!==undefined
      ? this.props.project.highlights
        .filter(report=>(report.stage===undefined && report.endProject!==true) || this.props.showEndStage===true || this.props.selected!==undefined && report.id===this.props.selected )
      : undefined;
    let labelsLanguage={
      norwegian: {
        title :"Statusrapport",
        noReportsAvailable: <i>Ingen statusrappor er tilgjengelig enda. Statusrapporter skrives i <a href={link}>"Progress" delen</a>.</i>,
        risks: "Risiko",
        issues: "Saker"
    },
      english: {
        title :"Highlight Report",
        noReportsAvailable: <i>No highlight report available yet. Highlight reports are written in the <a href={link}>"Progress" area</a>.</i>,
        risks: "Risks",
        issues: "Issues"
      }
    }
    let labels=(labelsLanguage[this.props.language] || labelsLanguage["english"]);
    var layout=undefined;
    if (this.props.tenant.design!==undefined) {
      if (this.props.tenant.design.reportLogo!==undefined && this.props.tenant.design.reportLogo!==null) {
        layout={
          reportLogo: this.props.tenant.design.reportLogo
        };
      } else {
        layout=Object.assign({},this.props.tenant.design,{useLogo:true});
      }
    }
    var pageNo="{{page}}";
    var pages="{{pages}}";
    var style=Object.assign({},{maxWidth:1016, textAlign:"left", pageBreakInside:"avoid"},this.props.settings!==undefined ? this.props.settings.style : undefined);
    var selected=reports!==undefined ? reports.filter(report=>report.id===this.props.selected)[0] : undefined;
    if (selected===undefined && (this.props.selected==="draft" || this.props.selected==="preview") && this.props.project.draftHighlight!==undefined && this.props.user.id===this.props.project.draftHighlight.updatedBy) {
      selected=Object.assign({},this.props.project.draftHighlight,{
        summary:this.props.project.draftHighlight.overallStatus,
        date: this.props.project.draftHighlight.statusDate,
        type:this.props.selected,
        risk: Object.assign({},this.props.project.draftHighlight.risk, {
          items: this.props.project.isProgramme || this.props.project.isProduct ? this.props.risks : this.props.project.risks
        }),
        change: this.props.includeChange ? {
          items: this.props.project.isProgramme || this.props.project.isProduct ? this.props.issues : this.props.project.issues
        } : undefined
      });
    }
    var risk=selected!==undefined ? selected.risk : undefined; //this.props.project.highlights!==undefined ? this.props.project.highlights.slice(-1)[0].risk : undefined;
    var change=this.props.includeChange && selected!==undefined ? selected.change : undefined; //{items:this.props.project.issues} : undefined;
    let slides=[<HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={0} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={1} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={2} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={3} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={4} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={5} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={6} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={7} />,
                <HighlightReport {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={8} />
              ];
    let slideTitles=[<HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={0} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={1} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={2} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={3} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={4} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={5} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={6} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={7} />,
                <HighlightReportSlideTitle {...selected} language={this.props.language} project={this.props.project}
                                settings={this.props.settings} profile={this.props.profile} presentationMode={this.props.presentationMode}
                                slideNo={8} />
              ];
    return (
      <div style={{padding:5, paddingLeft:10, fontFamily: "Verdana, sans-serif", textAlign:"center"}}>
        {(reports===undefined || reports.length===0) && selected===undefined ? (
          <div style={{display:"inline-block", textAlign:"left"}}>
            <h2>{labels.title}</h2>
            {labels.noReportsAvailable}
          </div>
        ) : (
          <div style={{display:"inline-block",textAlign:"left"}}>
            {this.props.fullPage && layout!==undefined ? (
              <div style={{float:"right"}}>
                {layout.useLogo===undefined ? (
                  <img src={layout.reportLogo}/>
                ) : (
                  <div style={{marginTop:15, display:"inline-block", height:layout.height, width: layout.width, backgroundImage: "url('"+layout.logo+"')", backgroundPosition: layout.position, backgroundSize:layout.size!==undefined ? layout.size : "contain", backgroundRepeat: "no-repeat"}}></div>
                )}
              </div>
            ) : null}
            {this.props.settings!==undefined && this.props.settings.showFooter ? (
              <div id="pageFooter" style={{textAlign:"center", fontSize:"7pt", fontFamily:"Verdana"}}>{pageNo}/{pages}</div>
              ):null}
            {this.props.presentationMode!==true ? (<HighlightReport
             {...selected}
             language={this.props.language}
             project={this.props.project}
             settings={this.props.settings}
             profile={this.props.profile}
             presentationMode={this.props.presentationMode}
            />) : (
                <Slides slides={slides} slideTitles={slideTitles}/>
            )}
        </div>
        )}
        <div style={{position:"relative", pageBreakAfter:"always", pageBreakInside:"avoid"}}></div>
        {this.props.settings!==undefined && this.props.settings.includedRisk===false && risk!==undefined && risk.items!==undefined && risk.items!==null && risk.items.length>0 && risk.items.filter(item=>item.status!=="Closed").length>0 ? (
          <div style={style}>
            <h2>{labels.risks}</h2>
            <RiskReport {...this.props} settings={this.props.settings} items={risk.items.filter(item=>item.status!=="Closed")}/>
          </div>
        ) : null}
        {this.props.settings!==undefined && this.props.settings.includedIssues===false && change!==undefined && change.items!==undefined && change.items!==null && change.items.length>0 && change.items.filter(item=>item.status!=="Closed").length>0 ? (
          <div style={{position:"relative", pageBreakAfter:"always", pageBreakInside:"avoid"}}></div>
        ) : null}
        {this.props.settings!==undefined && this.props.settings.includedIssues===false && change!==undefined && change.items!==undefined && change.items!==null && change.items.length>0 && change.items.filter(item=>item.status!=="Closed").length>0 ? (
          <div style={style}>
            <h2>{labels.issues}</h2>
            <IssueReport {...this.props} settings={this.props.settings} items={change.items.filter(item=>item.status!=="Closed")}/>
          </div>
        ) : null}
      </div>
    );
  }
}

class ReportTitle extends React.Component {
  render() {
    let report=this.props;
    let date=new Date(report.date).toISOString().substring(0,10);
    return (
      <span>
        {this.props.isSelected ? (
          <b>
            {date}
          </b>
        ) : date}
        {report.type==="draft" ? (
          <span> (<i>draft</i>)</span>
        ) : report.version!==undefined ? (
          <span> (v{report.version})</span>
        ) : undefined}
      </span>
    );
  }
}

class ArchiveMenu extends React.Component {
  isSameDate(previous,current) {
    return new Date(previous.date).toISOString().slice(0,10)===new Date(current.date).toISOString().slice(0,10);
  }

  link(details) {
    return (
      this.props.project.isProgramme!==undefined
        ? "/programmes/"
        : this.props.project.isRelease!==undefined
          ? "/releases/"
          : this.props.project.isProduct!==undefined
            ? "/products/"
            : "/projects/"
      )+this.props.project.id+details;
  }

  render() {
    var reports=this.props.project.highlights!==undefined ?
      this.props.project.highlights.slice().sort(sortByDate).reverse()
      : [];
    reports=reports
      .reverse()
      .filter(report=>(report.stage===undefined && report.endProject!==true) || this.props.showEndStage || report.id===this.props.selected)
      .map((report,index,allReports)=>
        Object.assign({},report,{
          version:index>0 && this.isSameDate(allReports[index-1],report)
            ? allReports.slice(0,index).filter(reportEntry=>this.isSameDate(reportEntry,report)).length+1
            : undefined
          }
        )
      )
      .reverse();
    if (this.props.project.draftHighlight!==undefined && this.props.user.id===this.props.project.draftHighlight.updatedBy) {
      reports=[].concat(Object.assign({},this.props.project.draftHighlight,{date:this.props.project.draftHighlight.statusDate, id:"draft", type:"draft", summary: this.props.project.draftHighlight.overallStatus })).concat(reports);
    }
    return (
      <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        <div style={{paddingTop:30}}>
          <b>Report Actions</b>
          <div style={{paddingLeft:10}}>
            <a href={"?id="+this.props.selected+"&fullPage=true&lang="+this.props.language} target="_blank">View full screen</a>
          </div>
          <div style={{paddingLeft:10}}>
            <a href={"?id="+this.props.selected+"&fullPage=true&pdf=true&lang="+this.props.language} target="_blank">View PDF</a>
          </div>
          <div style={{paddingLeft:10}}>
            <a href={"?id="+this.props.selected+"&presentationMode=true&lang="+this.props.language} target="_blank">View slide mode</a>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <b>Report Archive</b>
          <div style={{paddingLeft:10}}>
            {reports.length>0 ? (
              reports
                .filter((report,index,allReports)=>
                      index==0 || !this.isSameDate(allReports[index-1],report) || report.id===this.props.selected
                )
                .map(report=>(
                <div key={report.id}>
                  {this.props.selected===report.id ? (
                    <div>
                      <ReportTitle {...report} isSelected={true}/>
                      {report.stage!==undefined || report.endProject===true ? <img style={{paddingLeft:5, height: "10pt"}} src="/images/Flag_FinishGrey_22x16.gif"/> : null}
                      {report.type==="draft" ? (
                        <span> <a href={this.link("/highlight")}>edit</a></span>
                      ) : null}
                      {report.id===reports[0].id && report.createdBy===this.props.user.id && this.props.project.draftHighlight===undefined? (
                        <span> <a href={this.link("/highlight?id="+report.id+(report.stage!==undefined ? "&endStage=true" : "")+(report.endProject===true ? "&endProject=true" : ""))}>edit</a></span>
                      ) : null}
                      {reports
                        .filter(historicReport=>this.isSameDate(historicReport,report) && (historicReport.version<report.version || historicReport.version===undefined && report.version!==undefined || report.type==="draft" && historicReport.type!=="draft"))
                        .map(historicReport=>(
                          <div key={historicReport.id} style={{paddingLeft:15}}>
                            <div>
                              <a href={"?id="+historicReport.id+(this.props.showEndStage ? "&showEndStage=true" : "")}><ReportTitle {...historicReport}/></a>
                              {historicReport.stage!==undefined ? <img style={{paddingLeft:5, height: "10pt"}}src="/images/Flag_FinishGrey_22x16.gif"/> : null}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <div>
                      <a href={"?id="+report.id+(this.props.showEndStage ? "&showEndStage=true" : "")}>
                        <ReportTitle {...report} isSelected={false}/>
                      </a>
                      {report.stage!==undefined ? <img style={{paddingLeft:5, height: "10pt"}}src="/images/Flag_FinishGrey_22x16.gif"/> : null}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <i>No reports are available</i>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export class ReportContent extends React.Component {
  render() {
    let selected=this.props.selected;
    return this.props.presentationMode ? (
        <Report {...this.props} selected={selected}/>
    ) : (
      <div>
        <ArchiveMenu {...this.props} selected={selected}/>
        <Report {...this.props} selected={selected}/>
      </div>
    );
  }
}

export default class ReportPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    let selected=this.props.selected;
    return this.props.fullPage ? (
      <Report {...this.props} selected={selected}/>
    ) : (
      <Layout {...this.props} projectMenu={menu}>
        <ReportContent {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Report.jsx